var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputFieldType } from 'models/Input/InputModels';
import { useMemo } from 'react';
import { PubTable } from 'components/Shared/PubTable/PubTable';
export function ProductSearchResults(_a) {
    var tableData = _a.tableData, showOptionalColumns = _a.showOptionalColumns, origin = _a.origin;
    var tableDefinition = useMemo(function () {
        var defaultTable = {
            firstColumnIndent: true,
            noDataMessage: 'No Products found',
            columns: [
                {
                    dataAttribute: 'prefix',
                    fieldType: InputFieldType.STRING,
                    heading: 'Product Prefix',
                    width: showOptionalColumns ? '7%' : '10%',
                    allowCopy: true,
                    index: 0,
                    setOverflowWrap: 'break-word',
                },
                {
                    dataAttribute: 'name',
                    fieldType: InputFieldType.STRING,
                    heading: 'Product Name',
                    width: showOptionalColumns ? '22%' : '27%',
                    allowCopy: true,
                    index: 1,
                },
                {
                    dataAttribute: 'legacyProductId',
                    fieldType: InputFieldType.STRING,
                    heading: 'Product Id',
                    width: showOptionalColumns ? '7%' : '10%',
                    allowCopy: true,
                    index: 2,
                },
                {
                    dataAttribute: 'discountString',
                    fieldType: InputFieldType.STRING,
                    heading: 'Discount',
                    width: showOptionalColumns ? '16%' : '23%',
                    index: 3,
                },
                {
                    dataAttribute: 'startDate',
                    fieldType: InputFieldType.STRING,
                    heading: 'Start Date',
                    width: showOptionalColumns ? '10%' : '15%',
                    index: 6,
                },
                {
                    dataAttribute: 'endDate',
                    fieldType: InputFieldType.STRING,
                    heading: 'End Date',
                    width: showOptionalColumns ? '10%' : '15%',
                    index: 7,
                },
            ],
            showAddRow: false,
            extraIconIsActionText: true,
            extraIcon: {
                icon: null,
            },
        };
        if (showOptionalColumns) {
            var cols = __spreadArray(__spreadArray(__spreadArray([], defaultTable.columns.slice(0, 4), true), [
                {
                    dataAttribute: 'standardProductRef',
                    fieldType: InputFieldType.STRING,
                    heading: 'Standard Product Ref.',
                    width: '16%',
                    index: 4,
                    setOverflowWrap: 'anywhere',
                },
                {
                    dataAttribute: 'deviations',
                    fieldType: InputFieldType.STRING,
                    heading: 'Deviations',
                    width: '12%',
                    index: 5,
                }
            ], false), defaultTable.columns.slice(4), true);
            defaultTable.columns = cols;
        }
        else if (defaultTable.columns.length > 5) {
            var indexOfVersion = defaultTable.columns.findIndex(function (item) { return item.dataAttribute === 'standardProductRef'; });
            if (indexOfVersion && indexOfVersion !== -1) {
                defaultTable.columns.splice(indexOfVersion, 2);
            }
        }
        return defaultTable;
    }, [showOptionalColumns]);
    return _jsx(PubTable, { def: tableDefinition, tableData: tableData, renderTableHeader: (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0, origin: origin });
}
